import { ActionPanel } from 'ui/flexSpacer';
import { FilterButton } from './FilterButton';
import { FreeFormSearch } from './FreeFormSearch';
import { StateTabs } from './StateTabs';
import { FacetWrapper, LeftSection } from './Styled';

export const ExperimentsIndexFacet = () => {
  return (
    <FacetWrapper>
      <LeftSection>
        <StateTabs />
      </LeftSection>
      <ActionPanel>
        <FilterButton />
        <FreeFormSearch />
      </ActionPanel>
    </FacetWrapper>
  );
};
